/***
 *
 * @file actions/DemoPage.ts
 * @description DemoPage actions will be used for API calls and logic.
 * @author Naveen Kumar
 * @organization Ingka Centres
 * @since 13 Feb 2024
 *
 */

import { APP_TAG_ID } from "@/config/app.config";
import { API } from "@/services/api.service"
import { T_DataRequestProps } from "@/types/app.type";

/**
 * Contains the API response data
 */
type T_ResData = {
    /** unique id of the response */
    id: number
}

/**
 * Name: getTopNavData
 * 
 * Description: makes an API call to fetch the contents with tag = "baseplate,menuGroup" from Contentful
 * 
 * @returns {object} API response from Contentful 
 */
export const getTopNavData = async ({tags = APP_TAG_ID, preview = false, id = "", locale}: T_DataRequestProps) => {
    const { data }: any = await API.getContent({ queryParams: { "metadata.tags.sys.id[all]": tags, "include": 10, "sys.id": id || '', ...(locale?{locale: locale}: {}) }, preview: preview });
    // const { message, data } = await API.getContent({ queryParams: { "metadata.tags.sys.id[all]": "meetingPlaceHammersmith,clusterNordic", "include": 10 } });
    return data;
}

export const getFooterData = async ({tags = APP_TAG_ID, preview = false, id = "", locale}: T_DataRequestProps) => {
    const { data }: any = await API.getContent({ queryParams: { "metadata.tags.sys.id[all]": tags, "include": 10, "sys.id": id || '', ...(locale?{locale: locale}: {}) }, preview: preview });
    return data;
}

export const getCopyrightData = async ({tags = APP_TAG_ID, preview = false, id = "", locale}: T_DataRequestProps) => {
    const { data }: any = await API.getContent({ queryParams: { "metadata.tags.sys.id[all]": tags, "include": 10, "sys.id": id || '', ...(locale?{locale: locale}: {}) }, preview: preview });
    return data;
}
